import React from 'react';

import { useCurrentUserPermissions, useCurrentUserStaff } from 'src/hooks/user';

import { usePeoById } from './usePeoById';

export const useCurrentUserPeo = () => {
  const { peoStaff } = useCurrentUserStaff();
  const { hasPeoRoles } = useCurrentUserPermissions();

  const peoId = React.useMemo(() => {
    if (!hasPeoRoles) return null;
    return peoStaff?.peo.id;
  }, [hasPeoRoles, peoStaff?.peo.id]);

  return usePeoById(peoId);
};
